import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  MenuProps,
  Text,
} from "@chakra-ui/react";
import { RiArrowDownSLine, RiTimeLine } from "@remixicon/react";

import MenuDescription from "@/common/components/MenuDescription";

export const periods = {
  pastHour: "Past hour",
  past7days: "Past 7 days",
  past30days: "Past 30 days",
  past3months: "Past 3 months",
  past6months: "Past 6 months",
} as const;
export const periodList = Object.keys(periods) as readonly Period[];
export type Period = keyof typeof periods;

export type PeriodPickerProps = Omit<MenuProps, "children"> & {
  value: Period;
  allowedPeriods?: Period[] | readonly Period[];
  onChange: (value: Period) => void;
};

export default function PeriodPicker({
  value,
  onChange,
  allowedPeriods = periodList,
  ...rest
}: PeriodPickerProps) {
  return (
    <Menu {...rest}>
      <MenuButton
        as={Button}
        leftIcon={
          <Text fontSize="lg" variant="dimmed">
            <RiTimeLine size={16} />
          </Text>
        }
        rightIcon={
          <Box fontSize="xl" mr={-2}>
            <RiArrowDownSLine size={16} />
          </Box>
        }
        size="sm"
        variant="input"
        {...rest}
      >
        {periods[value]}
      </MenuButton>
      <MenuList>
        <MenuDescription color="dimmed">Select time period</MenuDescription>
        <MenuOptionGroup
          value={value ?? "any"}
          onChange={(value) => onChange(value as Period)}
        >
          {allowedPeriods.map((period) => (
            <MenuItemOption key={period} value={period}>
              {periods[period]}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
}
